import { useMemo } from 'react'
import { BaseTable } from 'Features/Table/BaseTable.view'
import { ExtendedGridColDef } from 'Features/Table/BulkUpdateModal'
import {
  SheduleTableProps,
  ProductCleanChangeoverRowType,
} from './Scheduler.types'
import { Box } from '@mui/material'

const dataConfig = {
  required: [
    'line_code',
    'previous_product_code',
    'next_product_code',
    'remove_clean',
    'other_changeover',
  ],
  optional: [
    'remove_offset',
    'changeover_cost',
    'changeover_environmental_cost',
  ],
}

export const SchedulerProductCleanChangeoverTable = ({
  data,
  isLoading,
  updateTableData,
  uploadScheduleData,
  isUploading,
  isSaving,
  updateRowsStatus,
  predicate,
  deleteTableData,
  isDeleting,
  readOnly = false,
}: SheduleTableProps<ProductCleanChangeoverRowType>) => {
  // Handle data updates for BaseTable
  const handleDataUpdate = (
    changedRows: Record<number, ProductCleanChangeoverRowType>
  ) => {
    updateTableData(changedRows)
  }

  const columns: ExtendedGridColDef[] = useMemo(
    () => [
      {
        field: 'line_code',
        headerName: 'Line Code',
        type: 'string',
        flex: 1,
      },
      {
        field: 'previous_product_code',
        headerName: 'Previous Product Code',
        type: 'string',
        flex: 1,
      },
      {
        field: 'next_product_code',
        headerName: 'Next Product Code',
        type: 'string',
        flex: 1,
      },
      {
        field: 'remove_clean',
        headerName: 'Remove Clean',
        type: 'string',
        flex: 1,
        editable: true,
      },
      {
        field: 'remove_offset',
        headerName: 'Remove Offset',
        type: 'string',
        flex: 1,
        editable: true,
      },
      {
        field: 'other_changeover',
        headerName: 'Other Changeover',
        type: 'string',
        flex: 1,
        editable: true,
      },
      {
        field: 'changeover_cost',
        headerName: 'Changeover Cost',
        type: 'number',
        flex: 1,
        editable: true,
      },
      {
        field: 'changeover_environmental_cost',
        headerName: 'Changeover Environmental Cost',
        type: 'number',
        flex: 1,
        editable: true,
      },
    ],
    [data]
  )

  return (
    <Box>
      <BaseTable
        data={data ?? []}
        columns={columns}
        isLoading={isLoading}
        updateTableData={handleDataUpdate}
        uploadData={uploadScheduleData}
        isUploading={isUploading}
        isSaving={isSaving}
        checkBoxSelection={true}
        showTableToolBar={true}
        downloadFileName="SchedulerProductCleanChangeover"
        onDeleteRows={deleteTableData}
        isDeleting={isDeleting}
        readOnly={readOnly}
        multiStageUpload={{
          uploadFile: uploadScheduleData,
          isUploading: isUploading,
          columns: columns,
          updateRowsStatus: updateRowsStatus,
          originalData: data,
          predicate: predicate,
          dataConfig: dataConfig,
        }}
        initialState={{
          pagination: { paginationModel: { pageSize: 100 } },
        }}
        sx={{
          maxWidth: 'calc(100vw - 70px)',
          '& .MuiDataGrid-cell--editable': {
            backgroundColor: '#CBD5E1',
          },
          '& .MuiBox-root': {
            padding: '0px !important',
          },
        }}
      />
    </Box>
  )
}
